var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", [
      _c(
        "div",
        { staticClass: "col-md-12 no-padding" },
        [
          _c("section-title", { attrs: { title: _vm.$t("message.vendor") } }),
          _vm._v(" "),
          _c("div", { staticClass: "form-row mb-2" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("message.storecompanyperson")))
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  staticClass: "form-control form-control-sm custom-select",
                  attrs: { disabled: true }
                },
                [
                  _vm.po.vendor
                    ? _c("option", [_vm._v(_vm._s(_vm.po.vendor.vendor_name))])
                    : _vm._e()
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row mb-2" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "form-group row mb-1" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("message.address")))]),
                  _vm._v(" "),
                  _c(
                    "textarea",
                    {
                      staticClass: "form-control",
                      staticStyle: { height: "91px" },
                      attrs: { disabled: true }
                    },
                    [_vm._v(_vm._s(_vm.po.vendor.address))]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "form-group row mb-1" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("message.tel")))]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { disabled: true, type: "text" },
                    domProps: {
                      value: _vm.getPartnerContact(_vm.po.vendor.contacts).tel
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row mb-0" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("message.email")))]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { disabled: true, type: "text" },
                    domProps: {
                      value: _vm.getPartnerContact(_vm.po.vendor.contacts).email
                    }
                  })
                ])
              ])
            ])
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        { staticClass: "col-md-12 no-padding" },
        [
          _c("section-title", {
            attrs: {
              title:
                _vm.$t("message.reference") + " & " + _vm.$t("message.date")
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", [_vm._v(_vm._s(_vm.$t("documents.po")))]),
              _vm._v(" "),
              _c(
                "select",
                {
                  staticClass: "form-control form-control-sm custom-select",
                  attrs: { disabled: true }
                },
                [_c("option", [_vm._v(_vm._s(_vm.po.po_code))])]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("apps.inventory.message.receiptdate")))
                ]),
                _vm._v(" "),
                _c("BaseInputDatePicker", {
                  model: {
                    value: _vm.form.scheduled_at,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "scheduled_at", $$v)
                    },
                    expression: "form.scheduled_at"
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        { staticClass: "col-md-12 no-padding" },
        [
          _c("section-title", {
            attrs: { title: _vm.$t("apps.inventory.message.shipto") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-row mb-2" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.warehouse_id,
                      expression: "form.warehouse_id"
                    }
                  ],
                  staticClass: "form-control form-control-sm custom-select",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "warehouse_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                _vm._l(_vm.warehouses, function(item, index) {
                  return item.is_deleted == false
                    ? _c("option", { domProps: { value: item.warehouse_id } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.warehouse_name) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                }),
                0
              )
            ])
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "mb-0" }, [
      _c(
        "div",
        { staticClass: "col-md-12 no-padding" },
        [
          _c("section-title", {
            attrs: { title: _vm.$t("message.orderlist") }
          }),
          _vm._v(" "),
          !_vm.form.orders.length
            ? _c("BaseNotFoundData", {
                staticClass: "mb-2",
                attrs: { title: _vm.$t("message.notfoundorders") }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isRenderOrders
            ? _c("OrderGR", {
                staticClass: "custom-order-gr",
                attrs: {
                  data: _vm.form.orders,
                  createAble: false,
                  showProductImage: true,
                  selectedWhId: _vm.form.warehouse_id,
                  addItemAble: true,
                  deleteItemAble: true,
                  changeSkuAble: true,
                  defaultItems: false,
                  optionBinLocations: _vm.optionBinLocations
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-row mb-3" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.note,
                    expression: "form.note"
                  }
                ],
                staticClass: "form-control form-control-sm",
                staticStyle: { "min-height": "90px" },
                attrs: { placeholder: _vm.$t("placeholder.note") },
                domProps: { value: _vm.form.note },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.form, "note", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c(
                  "vs-checkbox",
                  {
                    staticStyle: {
                      float: "left",
                      position: "relative",
                      top: "0",
                      left: "-5px"
                    },
                    attrs: { color: "#A3CA76" },
                    model: {
                      value: _vm.form.received,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "received", $$v)
                      },
                      expression: "form.received"
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("apps.inventory.message.allitemswerereceived")
                        ) +
                        "\n          "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48f0d7f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48f0d7f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/FormGoodsReceipt.vue
// module id = null
// module chunks = 